import {
  PACKAGE_LOADING,
  PACKAGE_END_LOADING,
  PACKAGE_LOADING_OPERATION,
  PACKAGE_END_LOADING_OPERATION,
  PACKAGE_GET_DATA,
  PACKAGE_GET_ITEM,
  PACKAGE_GET_ITEM_ARTICLES,
  PACKAGE_UPDATE_ARTICLE_STATUS,
  PACKAGE_DELETE_ELEMENT,
  PACKAGE_CLEAR,
  PACKAGE_CREATE_AND_ADD,
  PACKAGE_GET_ELEMENTS,
} from "../redux/types";
import * as api from "./api";

/**
 * Obtiene todos los paquetes del cliente actual
 */
export const getClientPackages =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/packages/getcurrents",
      loadingType: PACKAGE_LOADING,
      successType: PACKAGE_GET_DATA,
      errorType: PACKAGE_END_LOADING,
      data,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Obtiene todos los paquetes del cliente actual
 */
export const getClientPackageById =
  (id_package: string | number, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: `/packages/getbyid/${id_package}`,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_GET_ITEM,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Crea un nuevo paquete
 */
export const createClientPackage =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/packages/createfor_client",
      data,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_GET_ITEM,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (callbackFN) callbackFN(response.data?.id);
  };

/**
 * Actualiza un paquete
 */
export const updateClientPackage =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/packages/updatefor_client",
      data,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_GET_ITEM,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Marcar un paquete como completado
 */
export const markClientPackageCompleted =
  (id, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: `/packages/mark_as_completed/${id}`,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_GET_ITEM,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (response?.data?.articles) {
      dispatch({
        type: PACKAGE_GET_ITEM_ARTICLES,
        payload: response.data.articles,
      });
    }
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Elimina un paquete
 */
export const deleteClientPackage =
  (id, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/packages/removefor_client/${id}`,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_DELETE_ELEMENT,
      errorType: PACKAGE_END_LOADING_OPERATION,
      successPayload: {
        id,
      },
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Obtiene todos los articulos para un paquete
 */
export const getClientArticlesForPackage =
  (id_package, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: `/packages/getarticles/${id_package}`,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_GET_ITEM_ARTICLES,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const updateArticlePackageStatus =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/packages/updatearticle_status",
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_UPDATE_ARTICLE_STATUS,
      errorType: PACKAGE_END_LOADING_OPERATION,
      data,
      successPayload: data,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

// Admin ============
/**
 * Obtener paquetes desde estado admin
 */
export const getAdminPackages =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/packages/get_all",
      data,
      loadingType: PACKAGE_LOADING,
      successType: PACKAGE_GET_DATA,
      errorType: PACKAGE_END_LOADING,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Obtener todos los paquetes sin paginacion
 */
export const getAbsPackages =
  (callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/packages/get_abs_all",
      loadingType: PACKAGE_LOADING,
      successType: PACKAGE_GET_ELEMENTS,
      errorType: PACKAGE_END_LOADING,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const createPackage =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/packages/create",
      data,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_CREATE_AND_ADD,
      errorType: PACKAGE_END_LOADING_OPERATION,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const deletePackage =
  (id, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/packages/delete/${id}`,
      loadingType: PACKAGE_LOADING_OPERATION,
      successType: PACKAGE_DELETE_ELEMENT,
      errorType: PACKAGE_END_LOADING_OPERATION,
      successPayload: {
        id,
      },
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

// Utilidades
export const clearCurrentPackage = () => (dispatch) => {
  dispatch({
    type: PACKAGE_CLEAR,
  });
};
